import { render, staticRenderFns } from "./ClientSettings.vue?vue&type=template&id=3bcab2c8"
import script from "./ClientSettings.vue?vue&type=script&lang=js"
export * from "./ClientSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bcab2c8')) {
      api.createRecord('3bcab2c8', component.options)
    } else {
      api.reload('3bcab2c8', component.options)
    }
    module.hot.accept("./ClientSettings.vue?vue&type=template&id=3bcab2c8", function () {
      api.rerender('3bcab2c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientSettings.vue"
export default component.exports